import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { IconButton, Icon, Panel } from 'rsuite'
import InputDataTableForm from '../../../components/forms/input/InputDataTableForm'
import InputDataTableView from '../../../components/forms/input/InputDataTableView'
import scrollToComponent from 'react-scroll-to-component'
import { useForm, Controller } from 'react-hook-form'
import {
  updateConceptual,
  saveConceptual,
  deleteConceptual,
  getConceptual,
} from '../../../redux/actions/objectiveGoal'
import { startLoading, doneLoading } from '../../../utils/loading'
import { getSchemaSidebar, getSchemaSubProjectSidebar } from '../../../redux/actions/sidebar'
import WarningMessage from '../../../components/message/WarningMessage/WarningMessage'

export default function ConceptualWidget(props) {
  const { showCommandButton, isEdit, onChangeIsEdit, isSubProject } = props
  const [section, setSection] = useState()
  const [isError, setIsError] = useState(false)
  const [isDeleteError, setIsDeleteError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const { register, handleSubmit, errors, control, setValue, clearErrors } = useForm()
  const [formSchema, setFormSchema] = useState(props.schema)

  const dispatch = useDispatch()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  const handleUpdateSave = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      let response

      if (request.id) {
        response = await updateConceptual(projectId, request)
      } else {
        response = await saveConceptual(projectId, request)
      }

      if (response) {
        setFormSchema(response)
        try {
          await dispatch(getSchemaSidebar(projectId))
        } catch (e) {}
      } else {
        setIsError(true)
      }
    } catch (e) {
      console.log('e', e)
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  // const handleUpdateSaveSubProject = async (request) => {
  //   startLoading()
  //   setIsLoading(true)
  //   setIsError(false)
  //   try {
  //     let response

  //     if (request.id) {
  //       console.log('call subproject update.')
  //       response = await updateSubProjectObjective(projectId, request.id, request)
  //     } else {
  //       console.log('call subproject save.')
  //       response = await saveSubProjectObjective(projectId, request)
  //     }
  //     console.log('response', response)

  //     if (response) {
  //       setFormSchema(response)
  //       try {
  //         await dispatch(getSchemaSubProjectSidebar(projectId))
  //       } catch (e) {}
  //     } else {
  //       setIsError(true)
  //     }
  //   } catch (e) {
  //     console.log('e', e)
  //     setIsError(true)
  //   }
  //   setIsLoading(false)
  //   doneLoading()
  // }

  const handleDelete = async (schema) => {
    startLoading()
    setIsLoading(true)
    setIsDeleteError(false)
    try {
      console.log('call delete.')
      const status = await deleteConceptual(projectId, schema.id)
      if (status === 200) {
        console.log('call get.')
        const _schema = await getConceptual(projectId)
        // console.log(('result', _schema))
        setFormSchema(_schema)
      } else {
        setIsDeleteError(true)
      }
    } catch (e) {
      console.log('e', e)
      setIsDeleteError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  // const handleDeleteSubProject = async (schema) => {
  //   startLoading()
  //   setIsLoading(true)
  //   setIsDeleteError(false)
  //   try {
  //     console.log('call delete.')
  //     const status = await deleteSubProjectConceptual(projectId, schema.id)
  //     if (status === 200) {
  //       console.log('call get.')
  //       const _schema = await getSubProjectConceptual(projectId)
  //       // console.log(('result', _schema))
  //       setFormSchema(_schema)
  //     } else {
  //       setIsDeleteError(true)
  //     }
  //   } catch (e) {
  //     console.log('e', e)
  //     setIsDeleteError(true)
  //   }
  //   setIsLoading(false)
  //   doneLoading()
  // }

  const onSubmit = (data) => {
    console.log('data', data)

    let dataList = [...formSchema.conceptual.value]
    let id
    if (data.selectedIndex != -1) {
      id = dataList[data.selectedIndex]?.id
    }

    // if (isSubProject) {
    //   handleUpdateSaveSubProject({
    //     id: id,
    //     value: data.objective,
    //   })
    // } else {
    handleUpdateSave({
      id: id,
      value: data.conceptual,
    })
    // }
  }

  const onDelete = (index) => {
    let dataList = [...formSchema.conceptual.value]
    console.log(dataList[index])
    // if (isSubProject) {
    //   handleDeleteSubProject(dataList[index])
    // } else {
    handleDelete(dataList[index])
    // }
  }

  return (
    <Panel
      shaded
      header={formSchema.header}
      collapsible
      defaultExpanded
      ref={(section) => {
        setSection(section)
      }}
    >
      <WarningMessage style={{ marginTop: -10 }} message={formSchema?.feedbackBySubject} />

      {isEdit && showCommandButton ? (
        <InputDataTableForm
          key="key-conceptual"
          schema={formSchema.conceptual}
          register={register}
          Controller={Controller}
          control={control}
          errors={errors}
          setValue={setValue}
          clearErrors={clearErrors}
          onSubmit={handleSubmit(onSubmit)}
          onDelete={onDelete}
          isError={isError}
          isDeleteError={isDeleteError}
          loading={isLoading}
        />
      ) : (
        <InputDataTableView schema={formSchema.conceptual} />
      )}

      {showCommandButton && (
        <>
          <hr />
          {isEdit ? (
            <div>
              <IconButton
                appearance="ghost"
                className="rs-btn-ghost-info"
                icon={<Icon icon="backward" className="bt-gost-icon-radius-info" />}
                onClick={(e) => {
                  onChangeIsEdit(!isEdit)
                  setIsError(false)
                  setIsDeleteError(false)
                  scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
                }}
                disabled={isLoading}
              >
                {'ดูรายการ' + (formSchema.buttonText ? formSchema.buttonText : '')}
              </IconButton>
            </div>
          ) : (
            <IconButton
              appearance="ghost"
              className="rs-btn-ghost-edit"
              onClick={() => {
                onChangeIsEdit(!isEdit)
                setIsError(false)
                setIsDeleteError(false)
                scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
              }}
              icon={<Icon icon="edit" className="bt-gost-icon-radius-edit" />}
              disabled={isLoading}
            >
              {'เพิ่ม/แก้ไข' + (formSchema.buttonText ? formSchema.buttonText : '')}
            </IconButton>
          )}
        </>
      )}
    </Panel>
  )
}
